import { styled } from '@mui/material';
import { MuiTrackerButton } from '../components/TrackerButtonWrapper';

export const MainButton = styled(MuiTrackerButton)(({ theme }) => ({
  height: theme.spacing(6),
  borderRadius: theme.spacing(1),
  marginTop: theme.spacing(2),
}));
